/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import { string, bool, func } from 'prop-types';
import classNames from 'clsx';

import styles from './text-area.scss';

/**
 * This is the TextArea component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
const TextArea = ({
  name,
  placeholder,
  value,
  required,
  readOnly,
  error,
  onFocus,
  onBlur,
  onChange,
}) => (
  <div className={styles.wrapper}>
    <textarea
      id={name}
      className={classNames(styles.input, {
        [styles.error]: error,
        [styles.readOnly]: readOnly,
      })}
      {...{
        name,
        placeholder,
        value,
        required,
        readOnly,
        onFocus,
        onBlur,
        onChange,
      }}
    />
  </div>
);

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
TextArea.propTypes = {
  name: string.isRequired,
  placeholder: string,
  value: string,
  required: bool,
  readOnly: bool,
  error: bool,
  onFocus: func,
  onBlur: func,
  onChange: func,
};

/**
 * Declare default props.
 *
 * @type {Object}
 */
TextArea.defaultProps = {
  placeholder: '',
  value: '',
  required: false,
  readOnly: false,
  error: false,
  onFocus: () => {},
  onBlur: () => {},
  onChange: () => {},
};

export default TextArea;
